import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import Header from './components/Header';
import Footer from './components/Footer';
import Contact from './pages/Contact';
import AboutUs from './pages/AboutUs';
import CorporateServices from './pages/CorporateServices';
import HumanResourceServices from './pages/HumanResourceServices';
import AccountingServices from './pages/AccountingServices';
import SocialMediaServices from './pages/SocialMediaServices';
import CoWorkingSpaces from './pages/CoWorkingSpaces';
import AdminContacts from './pages/AdminContacts';
import TermsAndConditions from './pages/TermsAndConditions';
import Legal from './pages/Legal';
import ScrollToTop from './components/ScrollToTop';

import './App.css';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <MainLayout />
              <Footer />
            </>
          }
        />
        <Route
          path="/contact"
          element={
            <>
              <Header />
              <Contact />
              <Footer />
            </>
          }
        />
        <Route
          path="/about"
          element={
            <>
              <Header />
              <AboutUs />
              <Footer />
            </>
          }
        />
        <Route
          path="/corporate-services"
          element={
            <>
              <Header />
              <CorporateServices />
              <Footer />
            </>
          }
        />
        <Route
          path="/hr-services"
          element={
            <>
              <Header />
              <HumanResourceServices />
              <Footer />
            </>
          }
        />
        <Route
          path="/accounting-services"
          element={
            <>
              <Header />
              <AccountingServices />
              <Footer />
            </>
          }
        />
        <Route
          path="/social-media-services"
          element={
            <>
              <Header />
              <SocialMediaServices />
              <Footer />
            </>
          }
        />
        <Route
          path="/co-working-spaces"
          element={
            <>
              <Header />
              <CoWorkingSpaces />
              <Footer />
            </>
          }
        />
        <Route
          path="/terms-and-conditions"
          element={
            <>
              <Header />
              <TermsAndConditions />
              <Footer />
            </>
          }
        />
        <Route
          path="/legal"
          element={
            <>
              <Header />
              <Legal />
              <Footer />
            </>
          }
        />
        <Route
          path="/admin/contacts"
          element={
            <>
              <Header />
              <AdminContacts />
              <Footer />
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
